import { PackageCardItem, PackageItemKey, ProductCardData } from 'components/modules/patientArea/home/packages/types'
import { uniqueId } from 'lodash'
import { CourseVariantData, PsychologyVariantData } from 'redux/slices/packages-slice'

import { IS_PRODUCTION } from './isDevelopment'

export const masterId = 328
export const controlId = 142

export const occasionalImg = '/patientArea/packages/tadalafila-tribulus-capsules.png'
export const capsulesImgGeneric = '/patientArea/thumbnails/thumbnail_pill_bottle.webp'
export const continuousImg = '/patientArea/thumbnails/thumbnail_sm_spray.webp'
export const sprayImgGeneric = '/patientArea/thumbnails/thumbnail_sm_spray.webp'

export const courseVariants: CourseVariantData[] = [
  {
    slug: 'control-program',
    variantId: controlId,
    price: 49,
    trailerSrc: 'https://content.jwplatform.com/videos/GBi8HVvB-JuFBV07V.mp4',
    thumbSrc: '/patientArea/thumbnails/control-trailer-thumbnail.webp',
    description:
      'Para retomar o controle de uma vez por todas! Um Programa que é o resultado de 25 anos de experiência em sexualidade. 90 dias de treinamento por vídeo e 2h20 de conteúdo. 13 técnicas divididas em 9 etapas de 10 dias, com o acompanhamento e o apoio diário, por e-mail ou pelo telefone, de nossos médicos especialistas.'
  },
  {
    slug: 'master-program',
    variantId: masterId,
    price: 49,
    trailerSrc: 'https://content.jwplatform.com/videos/3WYwwm9O-JuFBV07V.mp4',
    thumbSrc: '/patientArea/thumbnails/master-trailer-thumbnail.webp',
    description:
      'O programa MASTER é uma combinação de técnicas físicas e mentais que o ajudarão a compreender sua função erétil. 8 vídeos com 2h de conteúdo para aprender a recuperar e administrar melhor suas ereções e reduzir o estresse que poderia afetar sua sexualidade.'
  }
]

export const psychologyVariants: PsychologyVariantData[] = [
  {
    variantId: uniqueId('psychology'),
    amount: 1,
    price: 79
  },
  {
    variantId: uniqueId('psychology'),
    amount: 2,
    price: 150
  },
  {
    variantId: uniqueId('psychology'),
    amount: 4,
    price: 290
  },
  {
    variantId: uniqueId('psychology'),
    amount: 1 * 3,
    price: 79 * 3
  },
  {
    variantId: uniqueId('psychology'),
    amount: 2 * 3,
    price: 150 * 3
  },
  {
    variantId: uniqueId('psychology'),
    amount: 4 * 3,
    price: 290 * 3
  }
]

export const productsBasicDisplayData: ProductCardData[] = [
  {
    label: 'Clomipramina spray',
    description: ['- Retarda a ejaculação.', '- Spray sublingual com ação rápida.'],
    imgSrc: '/patientArea/packages/sm_spray_bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['prematureEjaculation'],
    slugs: ['/ejaculacao-precoce', '/quando-o-homem-ejacula-rapido'],
    customizedMed: true,
    minPrice: 63
  },
  {
    label: 'Paroxetina spray',
    description: [
      '- Auxilia no tratamento da ejaculação precoce, retardando a ejaculação.',
      '- Spray sublingual com ação rápida.'
    ],
    imgSrc: '/patientArea/packages/sm_spray_bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['prematureEjaculation'],
    slugs: ['/ejaculacao-precoce', '/quando-o-homem-ejacula-rapido'],
    customizedMed: true,
    minPrice: 55
  },
  // // Avanafil cápsulas - a preencher -----------------------------------------------
  // {
  //   label: 'Avanafil cápsulas',
  //   description: [''],
  //   imgSrc: '/patientArea/packages/pill-bottle.webp',
  //   offeringType: 'prescriptionDrug',
  //   pathologies: [''],
  //   slugs: [''],
  //   customizedMed: true
  // },
  {
    label: 'Dapoxetina cápsulas',
    description: ['Auxilia no tratamento da ejaculação precoce, retardando a ejaculação.'],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['prematureEjaculation'],
    slugs: ['/ejaculacao-precoce', '/quando-o-homem-ejacula-rapido'],
    customizedMed: true,
    minPrice: 50
  },
  {
    label: 'Paroxetina cápsulas',
    description: ['Auxilia no tratamento da ejaculação precoce, retardando a ejaculação.'],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['prematureEjaculation'],
    slugs: ['/ejaculacao-precoce', '/quando-o-homem-ejacula-rapido'],
    customizedMed: true,
    minPrice: 59
  },
  {
    label: 'Tadalafila + L-Arginina + Tribulus + Fentolamina spray',
    description: [
      '- Melhora a função erétil.',
      '- Reduz a fadiga.',
      '- Tem ação vasodilatadora.',
      '- Promove o aumento da fertilidade masculina.'
    ],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['erectileDysfunction'],
    slugs: ['/disfuncao-eretil', '/problemas-de-erecao', '/impotencia-sexual'],
    customizedMed: true,
    minPrice: 77
  },
  {
    label: 'Tadalafila + Protodioscina spray',
    description: [
      '- Combate a disfunção erétil.',
      '- Contém o princípio ativo do Tribulus terrestris.',
      '- Melhora a libido.',
      '- Aumenta os níveis de testosterona.',
      '- Reduz inflamações no corpo.',
      '- Aumenta a disposição física.'
    ],
    imgSrc: '/patientArea/packages/sm_spray_bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['erectileDysfunction'],
    slugs: ['/disfuncao-eretil', '/problemas-de-erecao', '/impotencia-sexual'],
    customizedMed: true,
    minPrice: 60
  },
  {
    label: 'Sildenafila spray',
    description: [
      '- Aumenta o fluxo sanguíneo no pênis durante a estimulação sexual.',
      '- Combate a disfunção erétil.',
      '- Inibe a enzima PDE5, combatendo a progressão da disfunção erétil.'
    ],
    imgSrc: '/patientArea/packages/sm_spray_bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['erectileDysfunction'],
    slugs: ['/disfuncao-eretil', '/problemas-de-erecao', '/impotencia-sexual'],
    customizedMed: true,
    minPrice: 139
  },
  // { // insert description ------------------------------------------------------------------------
  //   label: 'Alprostradil gel',
  //   description: [
  //     '-'
  //   ],
  //   imgSrc: '/landings/acne/products/zoomed_sm_tube.webp',
  //   offeringType: 'prescriptionDrug',
  //   pathologies: ['erectileDysfunction'],
  //   slugs: ['/disfuncao-eretil', '/problemas-de-erecao', '/impotencia-sexual'],
  //   customizedMed: true
  // },
  {
    label: 'Paroxetina + Tadalafila spray',
    description: [
      '- Melhora a função erétil.',
      '- Auxilia no tratamento da ejaculação precoce, retardando a ejaculação.',
      '- Aumenta o fluxo sanguíneo no pênis.'
    ],
    imgSrc: '/patientArea/packages/sm_spray_bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['prematureEjaculation', 'erectileDysfunction'],
    slugs: [
      '/disfuncao-eretil',
      '/problemas-de-erecao',
      '/impotencia-sexual',
      '/ejaculacao-precoce',
      '/quando-o-homem-ejacula-rapido'
    ],
    customizedMed: true,
    minPrice: 59
  },
  {
    label: 'Dapoxetina + Tadalafila cápsulas',
    description: [
      '- Melhora a função erétil.',
      '- Auxilia no tratamento da ejaculação precoce, retardando a ejaculação.',
      '- Aumenta o fluxo sanguíneo no pênis.'
    ],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['prematureEjaculation', 'erectileDysfunction'],
    slugs: [
      '/disfuncao-eretil',
      '/problemas-de-erecao',
      '/impotencia-sexual',
      '/ejaculacao-precoce',
      '/quando-o-homem-ejacula-rapido'
    ],
    customizedMed: true,
    minPrice: 51
  },
  {
    label: 'Clomipramina + Tadalafila cápsulas',
    description: [
      '- Auxilia no tratamento da ejaculação precoce, retardando a ejaculação.',
      '- Melhora a função erétil.',
      '- Aumenta o fluxo sanguíneo no pênis.'
    ],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['prematureEjaculation', 'erectionDysfunction'],
    slugs: [
      '/disfuncao-eretil',
      '/problemas-de-erecao',
      '/impotencia-sexual',
      '/ejaculacao-precoce',
      '/quando-o-homem-ejacula-rapido'
    ],
    customizedMed: true,
    minPrice: 67
  },
  {
    label: 'Creme noturno',
    description: [
      '- Eficaz contra a acne.',
      '- Ativos que promovem assepsia e hidratação.',
      '- Previne o envelhecimento da pele e a hiperpigmentação.',
      'A fórmula será adaptada pelo médico para atender as necessidades do seu caso.'
    ],
    imgSrc: '/landings/acne/products/cream_container.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['acne'],
    slugs: ['/dermatologia', '/acne', '/antibiotico-para-acne', '/tetraciclina'],
    customizedMed: true
  },
  {
    label: 'Creme noturno asebiol',
    description: [
      '- Poderoso complexo anti-acne.',
      '- Asebiol: combate as lesões inflamatórias da acne.',
      '- Peróxido de benzoíla: cria sobre a pele uma camada que reduz a quantidade e intensidade das lesões inflamatórias da acne.',
      '- Gel Aristoflex: veículo de qualidade superior que possibilita a penetração dos ativos na pele, com uma textura suave.'
    ],
    imgSrc: '/landings/acne/products/cream_container.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['acne,'],
    slugs: ['/dermatologia', '/acne', '/antibiotico-para-acne', '/tetraciclina'],
    customizedMed: true
  },
  {
    label: 'Finasterida + Saw Palmeto + Biotina cápsulas',
    activeIngredients: ['finasterida', 'saw palmeto', 'biotina'],
    description: ['- Combate a queda capilar.', '- Combate a hiperplasia prostática'],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['hairLoss'],
    slugs: ['/dermatologia', '/calvicie', '/finasterida', '/minoxidil', '/dutasterida'],
    customizedMed: true
  },
  {
    label: 'Gel secativo',
    description: [
      '- Saliskin: um ativo que promove a renovação celular e é eficaz no combate à acne.',
      '- Melaleuca: propriedades anti-inflamatórias e antibacterianas.',
      'Ao analisar o seu caso, o médico decidirá que princípios ativos e concentrações ideais para o seu tratamento.'
    ],
    imgSrc: '/landings/acne/products/zoomed_sm_tube.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['acne'],
    slugs: ['/dermatologia', '/acne', '/antibiotico-para-acne', '/tetraciclina'],
    customizedMed: true
  },
  {
    label: '+lib',
    description: [
      '- Suplemento natural desenvolvido por nossos médicos.',
      '- Promove a recuperação da libido e do prazer sexual.',
      '- Melhora a disposição física.',
      '- Atua nos sintomas da andropausa e na disfunção erétil.',
      '- Contém vitaminas que contribuem para potencializar os efeitos.'
    ],
    imgSrc: '/patientArea/thumbnails/men-power-support-square.webp',
    offeringType: 'phyto',
    pathologies: ['lowLibido', 'erectileDysfunction'],
    slugs: ['/disfuncao-eretil', '/problemas-de-erecao', '/impotencia-sexual', '/perda-de-libido'],
    customizedMed: false
  },
  {
    label: 'Maca Peruana + Tribulus + Marapuama',
    description: [
      '- Promove melhoria da libido.', // insert Marapuama facts
      '- Contribui com o aumento da produção de testosterona.',
      '- Ajuda a controlar a pressão arterial.'
    ],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'phyto',
    pathologies: ['lowLibido', 'erectileDysfunction'],
    slugs: ['/disfuncao-eretil', '/problemas-de-erecao', '/impotencia-sexual', '/perda-de-libido'],
    customizedMed: true
  },
  // { // Seems nonexistent on its own. Use description elsewhere. -----------------------------------------------
  //   label: 'Tribulus cápsulas',
  //   description: [
  //     // bulletize
  //     'Auxilia no equilíbrio hormonal em pacientes que apresentam alterações das funções sexuais devido a uma baixa concentração do hormônio dehidroepiandrosterona (DHEA) no organismo.'
  //   ],
  //   imgSrc: '/patientArea/packages/pill-bottle.webp',
  //   offeringType: 'phyto',
  //   pathologies: ['erectileDysfunction'],
  //   slugs: ['/disfuncao-eretil', '/problemas-de-erecao', '/impotencia-sexual'],
  //   customizedMed: true
  // },
  {
    label: 'Minoxidil + Trichoxidil + TrichoSol spray',
    activeIngredients: ['Minoxidil', 'Trichoxidil', 'TrichoSol'],
    description: [
      '- Poderosa combinação para estimular o crescimento capilar.',
      '- Ajuda a revitalizar as raízes dos cabelos, reduzindo a queda.',
      '- Prolonga a fase de crescimento do folículo capilar.',
      '- Estimula a vascularização do couro cabeludo.',
      'O TrichoSol é um veículo que potencializa a ação dos princípios ativos, além de dispensar o uso do álcool, que pode causar irritação e ressecamento.'
    ],
    imgSrc: '/patientArea/packages/lg_spray_bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['hairLoss'],
    slugs: ['/dermatologia', '/calvicie', '/finasterida', '/minoxidil', '/dutasterida'],
    customizedMed: true
  },
  {
    label: 'Minoxidil oral',
    description: [
      '- Ajuda a revitalizar as raízes dos cabelos, reduzindo a queda.',
      '- Prolonga a fase de crescimento do folículo capilar.',
      '- Estimula a vascularização do couro cabeludo.'
    ],
    imgSrc: '/patientArea/packages/pill-bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['hairLoss'],
    slugs: ['/dermatologia', '/calvicie', '/finasterida', '/minoxidil', '/dutasterida'],
    customizedMed: true
  },
  {
    id: controlId,
    label: 'Programa Control',
    description: [
      '- Aprenda 13 técnicas físicas e mentais para controlar sua ejaculação.',
      '- Treinamento online com 11 vídeo-aulas.',
      '- Suporte para suas dúvidas por email, quando precisar.',
      '- 90 dias de treinamento.'
    ],
    imgSrc: '/patientArea/thumbnails/control-program-thumbnail-square.webp',
    loopVideoSrc: '/landings/products/sexual_health/video-control-edited.mp4',
    courseLink: '/cursos/programa-control',
    offeringType: 'course',
    pathologies: ['prematureEjaculation', 'erectileDysfunction'],
    slugs: [
      '/ejaculacao-precoce',
      '/quando-o-homem-ejacula-rapido',
      '/disfuncao-eretil',
      '/problemas-de-erecao',
      '/impotencia-sexual'
    ],
    customizedMed: false
  },
  {
    id: masterId,
    label: 'Programa Master',
    description: [
      '- Combina técnicas físicas que promovem o controle sobre a função erétil.',
      '- Aprenda a recuperar e administrar melhor suas ereções e reduzir o estresse que pode afetar sua sexualidade.',
      '- 8 vídeos com 2h de conteúdo.'
    ],
    imgSrc: '/patientArea/thumbnails/master-program-thumbnail-square.webp',
    loopVideoSrc: '/landings/products/sexual_health/video-master-edited.mp4',
    courseLink: '/cursos/programa-master',
    offeringType: 'course',
    pathologies: ['erectileDysfunction', 'prematureEjaculation'],
    slugs: [
      '/disfuncao-eretil',
      '/problemas-de-erecao',
      '/impotencia-sexual',
      '/ejaculacao-precoce',
      '/quando-o-homem-ejacula-rapido'
    ],
    customizedMed: false
  },
  {
    label: 'Sabonete Anti-acne',
    description: [
      '- Ácido glicólico: ajuda na remoção da pele morta e estimula a renovação celular, contribuindo para a revitalização cutânea.',
      '- Controla a produção de sebo, inibe a formação de cravos e tem ação anti-inflamatória.',
      '- Reduz a vermelhidão e o inchaço.',
      'Seu médico analisará o seu caso e adaptará a formulação para maximizar a eficácia.'
    ],
    imgSrc: '/landings/acne/products/zoomed_lg_tube.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['acne'],
    slugs: ['/dermatologia', '/acne', '/antibiotico-para-acne', '/tetraciclina'],
    customizedMed: true
  },
  {
    label: 'Shampoo manipulado',
    description: [
      '- Ácido salicílico: ajuda na remoção da pele morta, combatendo a caspa e a coceira.',
      '- Piritionato de zinco: agente antibacteriano e antimicótico com efeito duradouro.',
      '- Octopirox: agente anticaspa que inibe a formação de substâncias irritantes que causam coceira.'
    ],
    imgSrc: '/patientArea/packages/dermatology/shampoo_bottle.webp',
    offeringType: 'prescriptionDrug',
    pathologies: ['dermatitis'],
    slugs: ['/dermatologia', '/dermatite'],
    customizedMed: true
  }
  // { // Omit this one from display for the time being. -----------------------------------------------
  //   label: 'Tadalafila cápsulas',
  //   description: [
  //     '- Combate a disfunção erétil.',
  //     '- Aumenta o fluxo sanguíneo no pênis.',
  //     '- Auxilia no tratamento da ejaculação precoce.'
  //   ],
  //   imgSrc: '/patientArea/packages/pill-bottle.webp',
  //   offeringType: 'prescriptionDrug',
  //   pathologies: ['erectileDysfunction'],
  //   customizedMed: true
  // },
]

export interface SexShopProduct {
  variantId: number
  label: string
  price: number
  amount: number
  description?: string
  imgSrc?: string
}

export const defaultSexShopProducts: SexShopProduct[] = [
  {
    variantId: 494,
    label: 'Egg Masturbador Peniano',
    price: 59,
    imgSrc: '/landings/products/sexual_health/egg_shadow_thumb.webp',
    amount: 0
  },
  {
    variantId: 493,
    label: 'Anel Peniano',
    price: 149,
    imgSrc: '/landings/products/sexual_health/ring_shadow_thumb.webp',
    amount: 0
  }
]

export const defaultSexShopProductsSmartfit: SexShopProduct[] = [
  {
    variantId: 494,
    label: 'Egg Masturbador Peniano',
    price: 53,
    imgSrc: '/landings/products/sexual_health/egg_shadow_thumb.webp',
    amount: 0
  },
  {
    variantId: 493,
    label: 'Anel Peniano',
    price: 134,
    imgSrc: '/landings/products/sexual_health/ring_shadow_thumb.webp',
    amount: 0
  }
]

export const allPackageItems: Record<PackageItemKey, PackageCardItem> = {
  messages: {
    key: 'messages',
    iconName: 'Send',
    content: 'Suporte ilimitado por mensagem para dúvidas'
  },
  adjustFormula: {
    key: 'adjustFormula',
    iconName: 'Warning',
    content: 'Adaptação da sua fórmula ao longo do tratamento'
  },
  masterCourse: {
    key: masterId,
    iconName: 'MedalStar',
    content: 'Programa Master: Terapia de controle da ereção'
  },
  controlCourse: {
    key: controlId,
    iconName: 'MedalStar',
    content: 'Programa Control: Terapia de controle da ejaculação'
  },
  psychology: {
    key: 'psychology',
    iconName: 'PersonalCard',
    content: 'Consulta com psicólogo especialista em sexualidade'
  },
  phyto: {
    key: 'phyto',
    iconName: 'Timer',
    content: 'Fitoterápico'
  }
}

export const courseItems = [allPackageItems.masterCourse, allPackageItems.controlCourse]
